export default "__VITE_ASSET__Dek78eDm__"